// Candidate edge persistence via store metadata (ARCHITECTURE.md §11, Issue #37).
//
// Semantic analysis produces candidate GraphEdges; they are serialized to the
// metadata table so buildProjectGraph can merge them into the DependencyGraph.

import { z } from "zod";

import { GraphEdgeSchema, type GraphEdge } from "../types.js";
import type { StoreHandle } from "./types.js";

export const CANDIDATE_EDGES_METADATA_KEY = "candidate_edges";

const CandidateEdgesArraySchema = z.array(GraphEdgeSchema);

/** Serialize candidate edges to store metadata. */
export function persistCandidateEdges(store: StoreHandle, edges: GraphEdge[]): void {
  store.backend.setMetadata(CANDIDATE_EDGES_METADATA_KEY, JSON.stringify(edges));
}

/**
 * Load persisted candidate edges. Returns an empty array when the key is
 * absent, JSON is invalid, or edge objects fail schema validation.
 */
export function loadCandidateEdges(store: StoreHandle): GraphEdge[] {
  const raw = store.backend.getMetadata(CANDIDATE_EDGES_METADATA_KEY);
  if (raw === undefined) return [];

  let parsed: unknown;
  try {
    parsed = JSON.parse(raw);
  } catch {
    return [];
  }

  const result = CandidateEdgesArraySchema.safeParse(parsed);
  return result.success ? result.data : [];
}
